import {
    type EntityPickerMenuProps,
    PlaceholderEntityPickerMenu,
    type SlashRootKind,
    SupplierPickerPanel
} from "./entityPickerMenuComponents.tsx";
import {type ComponentType} from "react";

/**
 * Picker UI per entity kind — shared by slash commands and inline entity chips.
 */
export const ENTITY_PICKER_MENU_COMPONENTS: Record<
    SlashRootKind,
    ComponentType<EntityPickerMenuProps>
> = {
    supplier: SupplierPickerPanel,
    category: (props) => (
        <PlaceholderEntityPickerMenu kindLabel="Category" {...props} />
    ),
    material: (props) => (
        <PlaceholderEntityPickerMenu kindLabel="Material" {...props} />
    ),
    plant: (props) => <PlaceholderEntityPickerMenu kindLabel="Plant" {...props} />,
    cost_center: (props) => (
        <PlaceholderEntityPickerMenu kindLabel="Cost center" {...props} />
    ),
};